<template>
  <div class="wrapper">
    <header class="comic-header">
      <div class="logo">
        <a href="http://www.toriyasaimiso.jp/" target="_blank">
          <img src="../assets/images/logo.svg" alt="株式会社まつや">
        </a>
      </div>
    </header>

    <div class="slick-wrap">
      <slick ref="slick" :options="slickOptions" dir="rtl">
        <div data-slide><img src="../assets/comic/002/p01.jpg" alt=""></div>
        <div data-slide><img src="../assets/comic/002/p02.jpg" alt=""></div>
        <div data-slide><img src="../assets/comic/002/p03.jpg" alt=""></div>
        <div data-slide><img src="../assets/comic/002/p04.jpg" alt=""></div>
        <div data-slide><img src="../assets/comic/002/p05.jpg" alt=""></div>
        <div data-slide><img src="../assets/comic/002/p06.jpg" alt=""></div>
        <div data-slide><img src="../assets/comic/002/p07.jpg" alt=""></div>
        <div data-slide><img src="../assets/comic/002/p08.jpg" alt=""></div>
        <div data-slide><img src="../assets/comic/002/p09.jpg" alt=""></div>
        <div data-slide><img src="../assets/comic/002/p10.jpg" alt=""></div>
        <div data-slide>
          <div class="comic-lastpage">
            <div class="bnr">
              <a href="https://www.toriyasaimiso.jp/shop/" class="bnr" target="_blank">
                <img src="static/assets/images/bnr_ec@sp.png" alt="東村アキコの味噌鍋革命セレクトセット">
              </a>
            </div>

            <div class="btn-comic-pager">
              <router-link :to="{ path: 'comic001' }" class="active">前の話</router-link>
              <router-link :to="{ path: 'comic003' }" class="active">次の話</router-link>
            </div>

            <router-link :to="{ path: '/' }" class="btn-comic-lastpage">
              <img src="../assets/images/btn_comic_lastpage.svg" alt="">
            </router-link>
          </div>
        </div>
        <div data-blank></div>
      </slick>
    </div>
  </div>
</template>

<script>
  import Slick from 'vue-slick'

  export default {
    components: {
      Slick
    },

    metaInfo: {
      title: '「まつや」オリジナル漫画 第2話 | とり野菜みそスペシャルサイト | とり野菜みそオンライン：株式会社まつや公式サイト'
    },

    data () {
      return {
        slickOptions: {
          infinite: false,
          rtl: true,
          speed: 300,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1023,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }
          ]
        }
      }
    },

    mounted () {
      this.changeLastSlide()
    },

    methods: {
      changeLastSlide () {
        const slide = this.$refs.slick
        const interval = 600
        let resizeTimer

        if (window.innerWidth < 1024) {
          slide.filter('[data-slide]')
        }

        window.addEventListener('resize', (event) => {
          if (resizeTimer !== false) {
            clearTimeout(resizeTimer)
            resizeTimer = setTimeout(() => {
              if (window.innerWidth < 1024) {
                slide.filter('[data-slide]')
              } else {
                slide.unfilter()
              }
            }, interval)
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "~slick-carousel/slick/slick.scss";
  @import "../assets/scss/_slick-theme.scss";
  @import "../assets/scss/common";
  @import "../assets/scss/comic";
</style>



// WEBPACK FOOTER //
// src/pages/Comic002.vue?36968208